export class UnreachableError extends Error {
    constructor(_value: never) {
        super("Unreachable code was reached");
        this.name = "UnreachableError";
    }
}
